import Vue from "vue"
import GetTextPlugin from "vue-gettext"
import translations from "../translations.json"

Vue.use(GetTextPlugin, {
  translations,
  availableLanguages: {
    it: "Italiano",
    en: "English",
  },
  defaultLanguage: "it",
})
